var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-step-layout", {
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function () {
            return [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t(
                      "application-standalone.pages.identifications.yourIdentifications"
                    )
                  ) +
                  "\n  "
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "content",
          fn: function () {
            return [
              _c("page-toggler-layout", {
                attrs: { "show-information-page": _vm.showInformationPage },
                scopedSlots: _vm._u([
                  {
                    key: "summary",
                    fn: function () {
                      return [
                        _c("identification-summary", {
                          attrs: { "show-errors": _vm.showErrors },
                          on: {
                            navigate: _vm.navigateToInformationPage,
                            "disable-save": function ($event) {
                              return _vm.$emit("disable-save", $event)
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "information",
                    fn: function () {
                      return [
                        _c("identification-information", {
                          attrs: {
                            "show-errors": _vm.showErrors,
                            "applicant-index":
                              _vm.togglerMetadata.applicantIndex,
                            "identification-index":
                              _vm.togglerMetadata.identificationIndex,
                            "applicant-id": _vm.togglerMetadata.applicantId,
                          },
                          on: { navigate: _vm.navigateToInformationPage },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
        {
          key: "navigation",
          fn: function () {
            return [
              _vm._t("navigation-toolbar", null, null, {
                handleNavigateNext: _vm.handleNavigateNext(),
                handleNavigateBack: _vm.handleNavigateBack(),
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }